module.exports = [{
      plugin: require('/opt/build/repo/ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
